export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ12.32440246.mp3";